module.exports = __webpack_public_path__ + "media/assets/partners/accupass-f0421c3359b397abd75a4767b649541b.svg";